import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "fury-exclude-lead-source",
  templateUrl: "./exclude-lead-source.component.html",
  styleUrls: ["./exclude-lead-source.component.scss"],
})
export class ExcludeLeadSourceComponent implements OnInit, OnDestroy {
  leadSourceForm = new FormGroup({
    leadSources: new FormControl(null, [Validators.required]),
  });
  ngUnsubscribe = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExcludeLeadSourceComponent>,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    if (this.data) this.getExcludeLeadSource();
  }

  getExcludeLeadSource() {
    this.apiService
      .get(
        `admin/settings/third-party-api/get-exclude-lead-sources/${this.data?.thirdPartyApiName}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          const excludeLeadSources: any[] = res.body.excludeLeadSources.map(
            (item: any) => item?.leadSource
          );
          this.leadSourceForm.get("leadSources").setValue(excludeLeadSources);
        }
      });
  }
  excludeLead() {
    if (this.leadSourceForm.valid) {
      this.apiService
        .patch(
          `admin/settings/third-party-api/save-exclude-lead-source/${this.data?.thirdPartyApiName}`,
          this.leadSourceForm.value
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res) {
              this.apiService.alert(res.body.message, ErrorType.Success);
              this.dialogRef.close();
            }
          },
          (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          }
        );
    } else {
      this.leadSourceForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
